import React, { forwardRef, useContext } from 'react';
import Controls from './Controls';
import ImageGallery from 'react-image-gallery';
import { CarouselContext } from './CarouselContext';
import { Loading } from 'components/Loading';
import './styles.scss';

const ImageCarousel = forwardRef(({}, ref) => {
    const {
        startDrag,
        onDrag,
        endDrag,
        imgTransform,
        isDragging,
        galleryImages,
        handleSlideChange,
        currentIndex,
        imageRefs,
        enableRotate = false,
        loading,
        setIsFullScreen,
    } = useContext(CarouselContext);

    const renderItem = item => {
        const i = galleryImages.indexOf(item);
        if (!imgTransform || !imgTransform[i]) return null;
        const { zoom = 1, x = 0, y = 0 } = imgTransform[i] || {};

        return (
            <div
                ref={el => imageRefs.current[i] = el}
                onMouseDown={startDrag}
                onMouseMove={onDrag}
                onMouseUp={endDrag}
                onMouseLeave={endDrag}
                className="image-gallery-container"
            >
                <img
                    src={item.original}
                    alt={item.original}
                    style={{
                        transform: `scale(${zoom}) translate(${x}px, ${y}px)`,
                        cursor: isDragging ? 'grabbing' : 'grab',
                    }}
                />
            </div>
        );
    };

    if (!galleryImages?.length) return null;

    return loading ? <Loading /> : (
        <div className="ratioHolder slide-container">
            <div onDoubleClick={() => setIsFullScreen(true)}>
                <ImageGallery
                    startIndex={currentIndex || 0}
                    items={galleryImages}
                    showFullscreenButton={false}
                    showPlayButton={false}
                    ref={ref}
                    onSlide={handleSlideChange}
                    renderItem={renderItem}
                    renderLeftNav={() => null}
                    renderRightNav={() => null}
                />
            </div>
            <Controls enableRotate={enableRotate} />
        </div>
    );
});

export default ImageCarousel;